import * as BenchlingUtil from 'BenchlingUtil';
import {ConnectionSchema} from 'instruments/connection-schemas/ConnectionSchemaConstants';
import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import {SCHEMA_TYPE_NAMES, SCHEMA_TYPES} from 'schemas/spec/SchemaConfigConstants';
import {Optional} from 'util/Types';

import {AssaySchema} from './AssaySchemaConstants';

export default function setWindowTitleForSchema(
  schema: Optional<AssaySchema | RequestTaskSchema | ConnectionSchema>,
  schemaType: keyof typeof SCHEMA_TYPES
): void {
  if (schema && schemaType) {
    BenchlingUtil.setWindowTitle(`${schema.name} - ${SCHEMA_TYPE_NAMES[schemaType]} Schemas`);
  }
}
